<template>
  <filter-wrapper v-model="form.name" @submit="submit" />
</template>

<script>
  import FilterWrapper from '@shared/components/filter-search';
  import { mapActions } from 'vuex';

  export default {
    components: {
      FilterWrapper
    },
    data: () => ({
      form: {
        name: ''
      }
    }),

    methods: {
      ...mapActions('db/databases/table', ['search']),

      submit: function() {
        this.search(this.form);
      }
    }
  };
</script>
